<div class="is-maes-header-sticky">
  <div fxFlex="50%" class="container-is-maes-header">
    {{ 'gwirio.beth' | translate }}
  </div>
  <div fxFlex="50%" class="container-is-maes-header-cod-marcio">
    <div class="label-opsiynau">
      <span class="label-opsiwn">
        <fa-icon icon="check-circle"></fa-icon>
      </span>
      <span class="label-opsiwn">
        <fa-icon icon="times-circle"></fa-icon>
      </span>
      <span class="label-opsiwn">
        <strong>N/A</strong>
      </span>
    </div>
  </div>
</div>

@for (field of field.fieldGroup; track field; let i = $index) {
  <div>
    <mat-divider></mat-divider>
    <div fxFlex="50%" class="container-is-maes-teitl">
      {{ model[i].teitl | translate }}
    </div>
    <div fxFlex="50%" class="container-is-maes-cod-marcio">
      <formly-group [field]="field"></formly-group>
    </div>
  </div>
}